var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-image"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],style:({ width: `${_vm.width}px`, height: `${_vm.height}px` }),attrs:{"title":_vm.title,"rel":"noopener","alt":`Cardbild ${_vm.index}`}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }